import { MutableRefObject, useCallback, useEffect } from 'react'

import { DialogStack } from 'ui/core'

export const useOutsideClick = (ref: MutableRefObject<any>, callback: (target: HTMLElement) => any, enabled = true) => {
  // sometimes outsideclick triggers by hidden programmatically created tags, that cause unwanted closing of dialogs
  // as an example: DowloadLink component create <a> tag and call click() method, if that component was placed
  // on popup, popup will be closed by outsideclick, because of that we check element visibility
  // TODO: move it to some common utils lib?
  const isVisible = (node: HTMLElement | SVGElement) => {
    const rects = node.getClientRects()
    return rects[0] && rects[0].width > 0 && rects[0].height > 0
  }
  const handleClick = useCallback(
    (event: any) => {
      // if not left button, do nothing
      if (event.button !== 0) {
        return
      }

      if (!enabled) {
        return
      }

      const stack = DialogStack.getInstance()

      const condition = ref?.current && !ref.current.contains(event.target) && isVisible(event.target)

      if (condition && stack.isOnTop(ref.current)) {
        callback(event.target)
      }
    },
    [callback, ref, enabled]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [handleClick])
}
